export const API_VERSIONS = {
  USERS: 'v2',
  THIRD_PARTIES: 'v2',
  CONTRACTS: 'v2',
  VEHICLES: 'v2',
  TYPES: 'v2',
  TAGS: 'v2',
  PRODUCTS: 'v2',
  TITLES: 'v2',
  ROLES: 'v2',
  GROUPS: 'v2',
  MANAGERS: 'v2',
  RATES: 'v2',
  MENUS: 'v2',
  CLAIMS: 'v2',
  CANCELLATIONS: 'v2',
  CONTRACT_CANCELLATIONS: 'v2',
  ACCOUNTING: 'v2',
  INVOICES: 'v2',
  COMMISSION_AGENTS: 'v2',
  DASHBOARD: 'v1',
  QUERY_BUILDER: 'v1'
};
